import { IExitPopUp } from './IExitPopUp';

export interface ITheme {
  id?: string;
  userId?: number;
  name?: string;
  imgDesktop?: string;
  imgMobile?: string;
  config?: IThemeCustomizerModel;
  linkedProducts?: number[];
  type?: string;
  campaigns?: number[];
}

export interface IThemeCustomizer {
  id: enTheme;
  name: string;
  icon: string;
  options: IThemeCustomizerOptions[];
}

export interface IThemeCustomizerOptions {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export interface IThemeCustomizerModel {
  id?: number;
  template?: string;
  bannerCenter?: string;
  bannerCenterMobile?: string;
  bannerTop?: string;
  bannerTopMobile?: string;
  bannerRight?: string;
  bannerYoutube?: string;
  labels?: ILabels;
  inputs?: IInputs;
  background?: IBackground;
  buttons?: IButtons;
  header?: IHeader;
  footer?: IFooter;
  languageBar?: ILanguageBar;
  shortageTimer?: IShortageTimer;
  toastMessages?: IToastMessages;
  themeName?: string;
  exitPopUp?: IExitPopUp;
}

export interface IFont {
  color?: string;
}

export interface ILabels {
  font?: IFont;
}

export interface IBorder {
  color?: string;
  size?: number;
  style?: string;
}

export interface IInputs {
  bgcolor?: string;
  font?: IFont;
  border?: IBorder;
}

export interface IBackground {
  color?: string;
  image?: string;
  useInMobile?: boolean;
}

export interface IButtons {
  bgcolor?: string;
  text?: string;
  bgcolorhover?: string;
  font?: IFont;
}

export interface IHeader {
  bgcolor?: string;
  font?: IFont;
}

export interface IFooter {
  font?: IFont;
}

export interface ILanguageBar {
  bgColor?: string;
  opacity?: number;
  font?: IFont;
}

export interface IShortageTimer {
  isActive?: boolean;
  bgColor?: string;
  font?: IFont;
  type?: string;
  message?: string;
  countTime?: number;
}

export interface IToastMessages {
  bgColor?: string;
  font?: IFont;
  animationType?: string;
}

export enum enTheme {
  HOTSITE = 14,
  WIDGET = 16,
  PADRAO = 18
}

export enum enCustomizationForm {
  ActionButton = 'actionButton',
  ToastMessages = 'toastMessages',
  ShortageTimer = 'shortageTimer',
  LanguageSelectBar = 'languageBar',
  Form = 'form',
  Background = 'background',
  PrincipalMedia = 'principalMedia',
  TopBanner = 'topBanner',
  SideBanner = 'sideBanner',
  WidgetPrincipalMedia = 'widgetPrincipalMedia'
}
